import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { LoaderComponent } from '../../loader/loader.component';
import { AbstractButtonComponent } from '../abstract-button.component';
import { CommonModule } from '@angular/common';

/**
 * Similar to swatch but presents checkbox icon instead
 */

export type TIconButton = 'default' | 'filled' | 'filled-dark';
@Component({
    standalone: true,
    imports: [LoaderComponent, CommonModule],
    selector: 'button[iconButton], a[iconButton]',
    templateUrl: './icon-button.html',
    styleUrls: ['./icon-button.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconButtonComponent extends AbstractButtonComponent {
    @Input()
    iconButton: TIconButton | undefined | '' = 'default';

    @Input()
    iconSize?: number;

    @HostBinding('class._animated-text')
    @Input()
    textAnimated?: string;

    protected variantInputName = 'iconButton';
}
